import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["enable", "fields", "systemSelect", "imosFields", "dataloyFields"]

  connect() {
    this.toggleEnabled()
    this.toggleSystem()
  }

  toggleEnabled() {
    const show = this.enableTarget.checked
    this.fieldsTarget.classList.toggle("d-none", !show)
  }

  toggleSystem() {
    const system = this.systemSelectTarget.value
    this.imosFieldsTarget.classList.toggle("d-none", system !== "IMOS")
    this.dataloyFieldsTarget.classList.toggle("d-none", system !== "Dataloy")
  }
}
